import React from 'react';
import PropTypes from 'prop-types';

import { List as MUIList } from '@material-ui/core';

export const List = props => <MUIList {...props} />;

List.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType,
  dense: PropTypes.bool,
  disablePadding: PropTypes.bool,
  subheader: PropTypes.node
};

export default List;
